import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageBlock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPackageBlock"><Path d="M10.5 20.5H3.5V3.5H8.5M8.5 3.5H15.5M8.5 3.5V9.5H15.5V3.5M15.5 3.5H20.5V9.5M15 14L20 19M20.3284 13.6716C21.8905 15.2337 21.8905 17.7663 20.3284 19.3284C18.7663 20.8905 16.2337 20.8905 14.6716 19.3284C13.1095 17.7663 13.1095 15.2337 14.6716 13.6716C16.2337 12.1095 18.7663 12.1095 20.3284 13.6716Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPackageBlock;
